import React, { useCallback } from 'react';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import { BookToTaxCode } from '../types';


type BookToTaxCodesAdminColumnRendererProps = {
  value: BookToTaxCode,
  rowIndex: number,
}

const BookToTaxCodesAdminColumnRendererFactory = ({
  showModalForEdit,
  showModalForRemove,
}: {
  showModalForEdit: (entity: BookToTaxCode) => void,
  showModalForRemove: (data: { entityToRemove: BookToTaxCode, rowIndex: number }) => void,
}) => {
  const BookToTaxCodesAdminColumnRenderer: React.FC<BookToTaxCodesAdminColumnRendererProps> = ({
    value: entity,
    rowIndex,
  }: BookToTaxCodesAdminColumnRendererProps) => {
    const showEditModal = useCallback(() => {
      showModalForEdit(entity);
    }, [entity]);

    const showRemoveModal = useCallback(() => {
      showModalForRemove({ entityToRemove: entity, rowIndex });
    }, [entity, rowIndex]);

    const isDeletable = entity.linkedFlag === 0;

    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Book To Tax Code"
          onClick={showEditModal}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>

        <button
          className="cell-icon-button"
          title="Remove Book To Tax Code"
          onClick={showRemoveModal}
          disabled={!isDeletable}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  };
  return BookToTaxCodesAdminColumnRenderer;
};

export default BookToTaxCodesAdminColumnRendererFactory;
